import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ADDITIONAL_DRIVER from 'constants/additionalDriver';
import utils from 'utils';
import PostResFlowTemplate from 'components/PostRes/PostResFlowTemplate';
import DiscardReservationModal from 'components/ReservationFlow/SharedModals/DiscardReservationModal';
import SessionTimeoutModal from 'components/modals/SessionTimeoutModal';
import { withRouter } from 'utils/hoc';
import AdditionalDriverEdit from './AdditionalDriverEdit';
import AdditionalDriverSTCBridge from './AdditionalDriverSTCBridge';

const { ADDITIONAL_DRIVER_PATH_CONFIG } = ADDITIONAL_DRIVER;

const AdditionalDriverFlow = (router) => {
  const handleRouteUpdate = () => {
    if (!window.pageXOffset) {
      utils.dom.scrollPage();
    }
    // Dispatch the analytics ready event to indicate a "new page load" (since this is a SPA)
    utils.analytics.init(utils.config.getPageInfo());
  };
  const pathname = router?.location?.pathname;

  return (
    <>
      <PostResFlowTemplate>
        <utils.OnUpdateWrapper pathname={pathname} onUpdate={handleRouteUpdate}>
          <Routes>
            <Route path={ADDITIONAL_DRIVER_PATH_CONFIG.edit[0]} exact element={<AdditionalDriverEdit />} />
            <Route path={ADDITIONAL_DRIVER_PATH_CONFIG.confirm[0]} exact element={<AdditionalDriverSTCBridge />} />
          </Routes>
        </utils.OnUpdateWrapper>
      </PostResFlowTemplate>
      <DiscardReservationModal />
      <SessionTimeoutModal />
    </>
  );
};

export default withRouter(AdditionalDriverFlow);
